export default ({
  searchList: [{
    text: "录取方式",
    key:'admission_method',
      children: [{
          text: "文过专排",
          id: "0",
        },
        {
          text: "专过文排",
          id: "1",
        },
        {
          text: "综合分",
          id: "2",
        },
      ],
    },
    {
      text: "录取概率",
      key:'lql',
      children: [{
          text: "从低到高",
          id: "lql2",
          value: 2,
        },
        {
          text: "从高到低",
          id: "lql1",
          value: 1,
        },
      ],
    },
    {
      text: "小分限制",
      key:'small_limit',
      children: [{
          text: "有英语限制",
          id: "small_limit1",
          value: 1,
        },
        {
          text: "有语文限制",
          id: "small_limit2",
          value: 2,
        },
        {
          text: "语英均有限制",
          id: "small_limit3",
          value: 3,
        },
        {
          text: "无小分限制",
          id: "small_limit4",
          value: 4,
        },
      ],
    },
    {
      text: "院校标签",
      key:'level',
      children: [
        {
          "text": "双一流",
          "id": "is_first_class_school"
        },
        {
          "text": "211工程",
          "id": "is_211"
        },
        {
          "text": "国家重点",
          "id": "is_national_key"
        },
        {
          "text": "省部共建",
          "id": "is_province_construction"
        },
        {
          "text": "11大音乐",
          "id": "is_11music"
        },
        {
          "text": "研究生硕士点",
          "id": "is_postgraduate"
        },
        {
          "text": "18所参照",
          "id": "is_18reference"
        },
        {
          "text": "8大传媒",
          "id": "is_8media"
        },
        {
          "text": "省属",
          "id": "is_province"
        },
        {
          "text": "八大纺织学院",
          "id": "is_8textile"
        },
        {
          "text": "八大轻工学院",
          "id": "is_8lightIndustry"
        },
        {
          "text": "部委院校",
          "id": "is_ministerial"
        },
        {
          "text": "30所独立",
          "id": "is_30independent"
        },
        {
          "text": "两电一邮",
          "id": "is_2email1"
        },
        {
          "text": "国防七子",
          "id": "is_7nationalDefense"
        },
        {
          "text": "九大美院",
          "id": "is_9artSchools"
        },
        {
          "text": "8大艺术学院",
          "id": "is_8artCollege"
        },
        {
          "text": "985工程",
          "id": "is_985"
        },
        {
          "text": "C9联盟",
          "id": "is_c9"
        },
        {
          "text": "建筑老八校",
          "id": "is_8oldBuilding"
        },
        {
          "text": "建筑新八校",
          "id": "is_8newBuilding"
        },
        {
          "text": "E9联盟",
          "id": "is_e9"
        },
        {
          "text": "九校联盟",
          "id": "is_9schools"
        },
        {
          "text": "常征集",
          "id": "is_collect"
        },
        {
          "text": "省重点",
          "id": "is_province_key"
        }
      ],
    },
    {
      text: "办学类型",
      key:'school_nature',
      children: [{
          text: "公办",
          id: "公办",
        },
        {
          text: "民办",
          id: "民办",
        },
        {
          text: "独立学院",
          id: "独立学院",
        },
        {
          text: "中外合作办学的专业",
          id: "中外合作办学的专业",
        },
      ],
    },
  ],
  searchSchoolList: [{
    text: "录取方式",
    key:'admission_method',
      children: [{
          text: "文过专排",
          id: "0",
        },
        {
          text: "专过文排",
          id: "1",
        },
        {
          text: "综合分",
          id: "2",
        },
      ],
    },
    {
      text: "小分限制",
      key:'small_limit',
      children: [{
          text: "有英语限制",
          id: "small_limit1",
          value: 1,
        },
        {
          text: "有语文限制",
          id: "small_limit2",
          value: 2,
        },
        {
          text: "语英均有限制",
          id: "small_limit3",
          value: 3,
        },
        {
          text: "无小分限制",
          id: "small_limit4",
          value: 4,
        },
      ],
    },
    {
      text: "院校标签",
      key:'level',
      children: [
        {
          "text": "双一流",
          "id": "is_first_class_school"
        },
        {
          "text": "211工程",
          "id": "is_211"
        },
        {
          "text": "国家重点",
          "id": "is_national_key"
        },
        {
          "text": "省部共建",
          "id": "is_province_construction"
        },
        {
          "text": "11大音乐",
          "id": "is_11music"
        },
        {
          "text": "研究生硕士点",
          "id": "is_postgraduate"
        },
        {
          "text": "18所参照",
          "id": "is_18reference"
        },
        {
          "text": "8大传媒",
          "id": "is_8media"
        },
        {
          "text": "省属",
          "id": "is_province"
        },
        {
          "text": "八大纺织学院",
          "id": "is_8textile"
        },
        {
          "text": "八大轻工学院",
          "id": "is_8lightIndustry"
        },
        {
          "text": "部委院校",
          "id": "is_ministerial"
        },
        {
          "text": "30所独立",
          "id": "is_30independent"
        },
        {
          "text": "两电一邮",
          "id": "is_2email1"
        },
        {
          "text": "国防七子",
          "id": "is_7nationalDefense"
        },
        {
          "text": "九大美院",
          "id": "is_9artSchools"
        },
        {
          "text": "8大艺术学院",
          "id": "is_8artCollege"
        },
        {
          "text": "985工程",
          "id": "is_985"
        },
        {
          "text": "C9联盟",
          "id": "is_c9"
        },
        {
          "text": "建筑老八校",
          "id": "is_8oldBuilding"
        },
        {
          "text": "建筑新八校",
          "id": "is_8newBuilding"
        },
        {
          "text": "E9联盟",
          "id": "is_e9"
        },
        {
          "text": "九校联盟",
          "id": "is_9schools"
        },
        {
          "text": "常征集",
          "id": "is_collect"
        },
        {
          "text": "省重点",
          "id": "is_province_key"
        }
      ],
    },
    {
      text: "办学类型",
      key:'school_nature',
      children: [{
          text: "公办",
          id: "公办",
        },
        {
          text: "民办",
          id: "民办",
        },
        {
          text: "独立学院",
          id: "独立学院",
        },
        {
          text: "中外合作办学的专业",
          id: "中外合作办学的专业",
        },
      ],
    },
  ],
  searchListAll: [
    "录取方式",
    "院校标签",
    "办学类型",
    "录取概率",
    "小分限制",
  ],
  config: {
    "sys_name": "艺考pc",
    "pc_logo": "\/upload\/image\/20220701\/9e6bc8e3d2b8fc36328d20d1f9c71c73.png",
    "copyright": "© 2014-2022 志愿工匠版权所有",
    "record_no": "津ICP备2021009409号-2",
    "wechat_img": "",
    "download_img": "",
    "middle_menu": [{
      "id": 1,
      "menu_img": "http:\/\/qiniuhd.handucode.top\/image\/20220218\/20220704\/165692939722371.png",
      "menu_txt": "找大学",
      "jump_url": "\/school\/school-list",
      "sort": 10,
      "is_hot": 1,
      "is_new": 1
    }, {
      "id": 2,
      "menu_img": "http:\/\/qiniuhd.handucode.top\/image\/20220218\/20220704\/165692939757852.png",
      "menu_txt": "选专业",
      "jump_url": "\/major\/search_major",
      "sort": 9,
      "is_hot": 0,
      "is_new": 1
    }, {
      "id": 3,
      "menu_img": "http:\/\/qiniuhd.handucode.top\/image\/20220218\/20220704\/165692939760045.png",
      "menu_txt": "招生简章",
      "jump_url": "\/general-list\/general-list",
      "sort": 8,
      "is_hot": 1,
      "is_new": 0
    }, {
      "id": 4,
      "menu_img": "http:\/\/qiniuhd.handucode.top\/image\/20220218\/20220704\/165692939789109.png",
      "menu_txt": "文化分测算器",
      "jump_url": "\/counter\/counter",
      "sort": 7,
      "is_hot": 0,
      "is_new": 0
    }, {
      "id": 5,
      "menu_img": "http:\/\/qiniuhd.handucode.top\/image\/20220218\/20220704\/165692939764689.png",
      "menu_txt": "综合分测算器",
      "jump_url": "\/counter\/composite_counter",
      "sort": 6,
      "is_hot": 0,
      "is_new": 0
    }, {
      "id": 6,
      "menu_img": "http:\/\/qiniuhd.handucode.top\/image\/20220218\/20220704\/165692939891503.png",
      "menu_txt": "校考合格线",
      "jump_url": "\/school-qualified\/school-qualified",
      "sort": 5,
      "is_hot": 0,
      "is_new": 1
    }, {
      "id": 7,
      "menu_img": "http:\/\/qiniuhd.handucode.top\/image\/20220218\/20220704\/165692939839204.png",
      "menu_txt": "填报",
      "jump_url": "\/fill\/volunteer",
      "sort": 4,
      "is_hot": 0,
      "is_new": 0
    }],
    "top_menu": [{
      "id": 45,
      "title": "首页",
      "jump_url": "/",
      "pid": 0,
      "sort": 99,
      "children": []
    }, {
      "id": 1,
      "title": "艺考填志愿",
      "jump_url": "#",
      "pid": 0,
      "sort": 10,
      "children": [{
        "id": 2,
        "title": "报考资讯",
        "jump_url": "\/news\/list",
        "pid": 1,
        "sort": 5,
        "children": [{
          "id": 3,
          "title": "艺考资讯",
          "jump_url": "\/informationlist/1.html",
          "pid": 2,
          "sort": 0,
          "children": []
        }, {
          "id": 4,
          "title": "考试大纲",
          "jump_url": "\/informationlist/2.html",
          "pid": 2,
          "sort": 0,
          "children": []
        },{
          "id": 6,
          "title": "招生简章",
          "jump_url": "\/informationlist/3.html",
          "pid": 2,
          "sort": 0,
          "children": []
        }, {
          "id": 7,
          "title": "统考简章",
          "jump_url": "\/informationlist/5.html",
          "pid": 2,
          "sort": 0,
          "children": []
        }, {
          "id": 8,
          "title": "省份政策",
          "jump_url": "\/informationlist/7.html",
          "pid": 2,
          "sort": 0,
          "children": []
        }, {
          "id": 9,
          "title": "解读与指导",
          "jump_url": "\/informationlist/8.html",
          "pid": 2,
          "sort": 0,
          "children": []
        }]
      }, {
        "id": 5,
        "title": "信息查询",
        "jump_url": "#",
        "pid": 1,
        "sort": 0,
        "children": [{
          "id": 6,
          "title": "查院校",
          "jump_url": "\/school\/school-list",
          "pid": 5,
          "sort": 0,
          "children": []
        }, {
          "id": 7,
          "title": "查专业",
          "jump_url": "\/major\/search_major",
          "pid": 5,
          "sort": 0,
          "children": []
        }]
      }, {
        "id": 10,
        "title": "快捷工具中心",
        "jump_url": "#",
        "pid": 1,
        "sort": 0,
        "children": [{
          "id": 11,
          "title": "批次线查询",
          "jump_url": "\/batch-line\/batch-line",
          "pid": 10,
          "sort": 0,
          "children": []
        }, {
          "id": 12,
          "title": "位次查询",
          "jump_url": "\/subsection\/subsection",
          "pid": 10,
          "sort": 0,
          "children": []
        }, {
          "id": 13,
          "title": "同分去向查询",
          "jump_url": "\/plug\/scoreconvert\/same-score-go",
          "pid": 10,
          "sort": 0,
          "children": []
        }, {
          "id": 14,
          "title": "招生简章查询",
          "jump_url": "\/general-list\/general-list",
          "pid": 10,
          "sort": 0,
          "children": []
        },  {
          "id": 16,
          "title": "艺术分数换算",
          "jump_url": "\/plug/scoreconvert\/scoreconvert",
          "pid": 10,
          "sort": 0,
          "children": []
        }]
      }, {
        "id": 17,
        "title": "测评中心",
        "jump_url": "#",
        "pid": 1,
        "sort": 0,
        "children": [{
          "id": 18,
          "title": "兴趣测评",
          "jump_url": "\/testing\/evaluations?type=1",
          "pid": 17,
          "sort": 0,
          "children": []
        }, {
          "id": 19,
          "title": "性格测评",
          "jump_url": "\/testing\/evaluations?type=2",
          "pid": 17,
          "sort": 0,
          "children": []
        }, {
          "id": 20,
          "title": "能力测评",
          "jump_url": "\/testing\/evaluations?type=3",
          "pid": 17,
          "sort": 0,
          "children": []
        }, {
          "id": 21,
          "title": "价值观测评",
          "jump_url": "\/testing\/evaluations?type=4",
          "pid": 17,
          "sort": 0,
          "children": []
        },
        // {
        //   "id": 22,
        //   "title": "意向测评",
        //   "jump_url": "\/testing\/evaluations?type=5",
        //   "pid": 17,
        //   "sort": 0,
        //   "children": []
        // }, {
        //   "id": 23,
        //   "title": "学习品质测评",
        //   "jump_url": "\/testing\/evaluations?type=6",
        //   "pid": 17,
        //   "sort": 0,
        //   "children": []
        // },
        ]
      }
      // , {
      //   "id": 24,
      //   "title": "报考课程",
      //   "jump_url": null,
      //   "pid": 1,
      //   "sort": 0,
      //   "children": [{
      //     "id": 25,
      //     "title": "低分段报考秘籍",
      //     "jump_url": "#",
      //     "pid": 24,
      //     "sort": 0,
      //     "children": []
      //   }, {
      //     "id": 26,
      //     "title": "中分段报考秘籍",
      //     "jump_url": "#",
      //     "pid": 24,
      //     "sort": 0,
      //     "children": []
      //   }, {
      //     "id": 27,
      //     "title": "高分段报考秘籍",
      //     "jump_url": "#",
      //     "pid": 24,
      //     "sort": 0,
      //     "children": []
      //   }, {
      //     "id": 28,
      //     "title": "热门专业讲解",
      //     "jump_url": "#",
      //     "pid": 24,
      //     "sort": 0,
      //     "children": []
      //   }]
      // }
    ]
    }, {
      "id": 905,
      "title": "找画室",
      "jump_url": "\/hospital\/hospital",
      "pid": 0,
      "sort": 0,
      "children": []
    },{
      "id": 904,
      "title": "数据大盘",
      "jump_url": "\/introduce\/data",
      "pid": 0,
      "sort": 0,
      "children": []
    }
    ,{
      "id": 44,
      "title": "综合评价",
      "jump_url": "\/introduce\/zongping",
      "pid": 0,
      "sort": 0,
      "children": []
    }, {
      "id": 901,
      "title": "中外合作",
      "jump_url": "\/introduce\/cooperation",
      "pid": 0,
      "sort": 0,
      "children": []
    }, {
      "id": 902,
      "title": "扬帆起航计划",
      "jump_url": "\/introduce\/set-sail",
      "pid": 0,
      "sort": 0,
      "children": []
    }, {
      "id": 903,
      "title": "家长先行计划",
      "jump_url": "\/introduce\/parents",
      "pid": 0,
      "sort": 0,
      "children": []
    }
  ],
    "banner": [{
      "id": 4,
      "base_img": "http:\/\/qiniuhd.handucode.top\/image\/20220713\/165767785583384.png",
      "img": "http:\/\/qiniuhd.handucode.top\/image\/20220713\/165767785583384.png",
      "jump_url": "1",
      "sort": 2
    }, {
      "id": 3,
      "base_img": "http:\/\/qiniuhd.handucode.top\/image\/20220713\/165767785583384.png",
      "img": "http:\/\/qiniuhd.handucode.top\/image\/20220713\/165767786252070.png",
      "jump_url": "https:\/\/www.baidu.com",
      "sort": 1
    }]
  },
  provinceList:[{"id":8,"province_name":"安徽","province_id":12,"province_code":"340000","province_en_name":"anhui","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655976232},{"id":7,"province_name":"北京","province_id":1,"province_code":"110000","province_en_name":"beijing","mode":2,"tianbao_mode":3,"status":1,"is_wenli":null,"all_batch_mode":3,"use_year":"2022","score_year":"2021","update_data_time":1655897151},{"id":19,"province_name":"重庆","province_id":22,"province_code":"500000","province_en_name":"chongqing","mode":3,"tianbao_mode":2,"status":1,"is_wenli":null,"all_batch_mode":2,"use_year":"2022","score_year":"2021","update_data_time":1655980025},{"id":6,"province_name":"福建","province_id":13,"province_code":"350000","province_en_name":"fujian","mode":3,"tianbao_mode":3,"status":1,"is_wenli":null,"all_batch_mode":2,"use_year":"2022","score_year":"2021","update_data_time":1656242836},{"id":18,"province_name":"甘肃","province_id":28,"province_code":"620000","province_en_name":"gansu","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655897151},{"id":4,"province_name":"广东","province_id":19,"province_code":"440000","province_en_name":"guangdong","mode":3,"tianbao_mode":3,"status":1,"is_wenli":null,"all_batch_mode":3,"use_year":"2022","score_year":"2021","update_data_time":1656166181},{"id":17,"province_name":"广西","province_id":20,"province_code":"450000","province_en_name":"guangxi","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655897151},{"id":24,"province_name":"贵州","province_id":24,"province_code":"520000","province_en_name":"guizhou","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1656057899},{"id":30,"province_name":"海南","province_id":21,"province_code":"460000","province_en_name":"hainan","mode":1,"tianbao_mode":2,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1656242836},{"id":5,"province_name":"河北","province_id":3,"province_code":"130000","province_en_name":"hebei","mode":3,"tianbao_mode":2,"status":1,"is_wenli":null,"all_batch_mode":2,"use_year":"2022","score_year":"2021","update_data_time":1655805599},{"id":9,"province_name":"河南","province_id":16,"province_code":"410000","province_en_name":"henan","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655823432},{"id":21,"province_name":"黑龙江","province_id":8,"province_code":"230000","province_en_name":"heilongjiang","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655805599},{"id":12,"province_name":"湖北","province_id":17,"province_code":"420000","province_en_name":"hubei","mode":3,"tianbao_mode":3,"status":1,"is_wenli":null,"all_batch_mode":3,"use_year":"2022","score_year":"2021","update_data_time":1655805599},{"id":13,"province_name":"湖南","province_id":18,"province_code":"430000","province_en_name":"hunan","mode":3,"tianbao_mode":3,"status":1,"is_wenli":null,"all_batch_mode":3,"use_year":"2022","score_year":"2021","update_data_time":1656057899},{"id":20,"province_name":"吉林","province_id":7,"province_code":"220000","province_en_name":"jilin","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655897151},{"id":1,"province_name":"江苏","province_id":10,"province_code":"320000","province_en_name":"jiangsu","mode":3,"tianbao_mode":3,"status":1,"is_wenli":null,"all_batch_mode":3,"use_year":"2022","score_year":"2021","update_data_time":1656092213},{"id":16,"province_name":"江西","province_id":14,"province_code":"360000","province_en_name":"jiangxi","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655897151},{"id":27,"province_name":"辽宁","province_id":6,"province_code":"210000","province_en_name":"liaoning","mode":3,"tianbao_mode":2,"status":1,"is_wenli":null,"all_batch_mode":2,"use_year":"2022","score_year":"2021","update_data_time":1655805599},{"id":28,"province_name":"内蒙古","province_id":5,"province_code":"150000","province_en_name":"neimenggu","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1656242836},{"id":25,"province_name":"宁夏","province_id":30,"province_code":"640000","province_en_name":"ningxia","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655897151},{"id":29,"province_name":"青海","province_id":29,"province_code":"630000","province_en_name":"qinghai","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1656242836},{"id":10,"province_name":"山东","province_id":15,"province_code":"370000","province_en_name":"shandong","mode":2,"tianbao_mode":2,"status":1,"is_wenli":null,"all_batch_mode":2,"use_year":"2022","score_year":"2021","update_data_time":1655824728},{"id":15,"province_name":"山西","province_id":4,"province_code":"140000","province_en_name":"shanxi2","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655992332},{"id":14,"province_name":"陕西","province_id":27,"province_code":"610000","province_en_name":"shanxi1","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655976232},{"id":2,"province_name":"上海","province_id":9,"province_code":"310000","province_en_name":"shanghai","mode":2,"tianbao_mode":3,"status":1,"is_wenli":null,"all_batch_mode":3,"use_year":"2022","score_year":"2021","update_data_time":null},{"id":11,"province_name":"四川","province_id":23,"province_code":"510000","province_en_name":"sichuan","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655988103},{"id":26,"province_name":"天津","province_id":2,"province_code":"120000","province_en_name":"tianjin","mode":2,"tianbao_mode":3,"status":1,"is_wenli":null,"all_batch_mode":3,"use_year":"2022","score_year":"2021","update_data_time":1655897151},{"id":31,"province_name":"西藏","province_id":26,"province_code":"540000","province_en_name":"xizang","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1656242836},{"id":22,"province_name":"新疆","province_id":31,"province_code":"650000","province_en_name":"xinjiang","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655818872},{"id":23,"province_name":"云南","province_id":25,"province_code":"530000","province_en_name":"yunnan","mode":1,"tianbao_mode":1,"status":1,"is_wenli":null,"all_batch_mode":1,"use_year":"2022","score_year":"2021","update_data_time":1655816343},{"id":3,"province_name":"浙江","province_id":11,"province_code":"330000","province_en_name":"zhejiang","mode":2,"tianbao_mode":2,"status":1,"is_wenli":null,"all_batch_mode":2,"use_year":"2022","score_year":"2021","update_data_time":1656168956}]
});
